import { ColumnDefinition, GridSlicerTypes } from 'features/gridReport/models';
import React from 'react';
import { Row, Col } from 'react-bootstrap';

interface MainFiltersRowProps {
  mainFilters: ColumnDefinition[];
  renderFilterComponent: (item: ColumnDefinition) => React.ReactNode;
}

export const MainFiltersRow: React.FC<MainFiltersRowProps> = ({
  mainFilters,
  renderFilterComponent,
}) => (
  <Row>
    {mainFilters.map(item => {
      const isConditional =
        item.filter_type === GridSlicerTypes.CONDITIONAL ||
        item.filter_type === GridSlicerTypes.DATE_PICKER;
      // Double width for CONDITIONAL: xs=12, sm=12, md=8, lg=4 (rest: xs=12, sm=6, md=4, lg=2)
      const colProps = isConditional
        ? { xs: 12, sm: 12, md: 8, lg: 4 }
        : { xs: 12, sm: 6, md: 4, lg: 2 };
      return (
        <Col key={String(item.field)} {...colProps}>
          {renderFilterComponent(item)}
        </Col>
      );
    })}
  </Row>
);
